import axios from "./_axios";
import { API } from "./apiEndPoints";

/**
 * Admin Portal — Account Adoption scoring configuration (ER-12307 / MDP-627).
 *
 * Thin wrappers over the v2 adoption scoring-config viewset (companion backend
 * tickets ER-12302 / ER-12305). A config is versioned and effective-dated:
 * "Save as new version" creates a new row; every account snapshot stores the
 * version it was computed with, so past snapshots are never recomputed.
 */

/**
 * List scoring config versions, newest first.
 */
export const getScoringConfigs = () =>
  axios()({
    method: "get",
    url: API.ADOPTION_SCORING_CONFIG,
  });

/**
 * Fetch a single scoring config version (used by the read-only "View" flow).
 *
 * @param {number|string} id Config version id.
 */
export const getScoringConfig = (id) =>
  axios()({
    method: "get",
    url: `${API.ADOPTION_SCORING_CONFIG}${id}/`,
  });

/**
 * Create a new scoring config version from the current draft.
 *
 * @param {object} data Full scoring config payload.
 */
export const createScoringConfig = (data) =>
  axios()({
    method: "post",
    url: API.ADOPTION_SCORING_CONFIG,
    data,
  });

/**
 * Compute the impact preview for an unsaved draft against the version in force.
 *
 * @param {object} data Full scoring config draft.
 */
export const previewScoringImpact = (data) =>
  axios()({
    method: "post",
    url: API.ADOPTION_IMPACT_PREVIEW,
    data,
  });
